import React from 'react';
import { ScrollView, Platform } from 'react-native';

export default (props) => <div class={props.wrapperClassName}>
    <ScrollView {...props}>
        {props.children || null}
    </ScrollView>
</div>